import Card from "../../../models/common/Card";
import cardImage from '../../../assets/img/partnerProgram/cardImage.png';
import cardImage2 from '../../../assets/img/partnerProgram/cardImage2.png';
import cardImage3 from '../../../assets/img/partnerProgram/cardImage3.png';
import iconOne from '../../../assets/img/proClub_public/education.png';
import iconTwo from '../../../assets/img/proClub_public/expertservices.png';
import iconThird from '../../../assets/img/proClub_public/news.png';
import iconFour from '../../../assets/img/proClub_public/expertservices.png';
import iconFive from '../../../assets/img/proClub_public/process.png';
import iconSix from '../../../assets/img/proClub_public/badge.svg';

// BANNER
export const TITLE = <div>The Dynatrace Partner Pro Club</div>;
export const SUB_TITLE = <div>Unlock exclusive access to Dynatrace training, insights into Dynatrace roadmap,<br></br> and have our experts on hand to help you drive cloud modernization at scale.</div>;
export const FIRST_BUTTON_NAME = "Get certified";
export const FIRST_BUTTON_LINK = "https://partners.dynatrace.com/#/page/enablement";
// export const SECOND_BUTTON_NAME = "Find out more";
// export const SECOND_BUTTON_LINK = "#cardsFormat2";
// --

// INTRODUCTION TEXT
export const INTRO_EYE_BROWN_HEADER = "WHY TURN PRO";
export const INTRO_TITLE = "You’ve got the skills, now reap the rewards";
export const INTRO_TEXT = <div>Take your career to the next level by becoming a member of our Partner Pro Club. Designed 
  exclusively for those who have achieved their Dynatrace Professional (and above) Certification, we’ve built a Pro Program that recognizes 
  your hard work and rewards your achievement and commitment with Dynatrace.</div>  
  // <br></br>
  // <br></br>
  // Our Pro Club Membership benefits include the opportunity to:  
  // <ul>
  //   <li>Attain a higher level of skills and effectiveness on the Dynatrace platform.</li>
  //   <li>Attend exclusive training and event invitations only available to our Pro Club members.</li>
  //   <li>Hear about new Dynatrace updates and enhancements before anyone else.</li>
  //   <li>Exclusive access to our Dynatrace experts and our Pro Club Ambassador Team. </li>
  //   <li>Career development – stand out from your peers and position yourself as a Dynatrace champion within your organization.</li>
  // </ul> 

  // </div>;

// BENEFITS CARDS
export const EYE_BROWN_HEADER_CARDS = "";
export const TITLE_CARDS = <div>Our Pro Club membership benefits <br></br> include the opportunity to:</div>;
export const SUB_TITLE_CARDS = "";
const card1: Card = new Card("", "Attain a higher level of skills and effectiveness on the Dynatrace platform.", iconOne);
const card2: Card = new Card("", "Attend exclusive training and event invitations only available to our Pro Club members.", iconTwo);
const card3: Card = new Card("", "Hear about new Dynatrace updates and enhancements before anyone else.", iconThird);
const card4: Card = new Card("", "Exclusive access to our Dynatrace experts and our Pro Club Ambassador Team.", iconFour);
const card5: Card = new Card("", "Career development – stand out from your peers and position yourself as a Dynatrace champion within your organization.", iconFive);
const card6: Card = new Card("", "Share your success with verified digital badges across your social platforms.", iconSix, undefined, undefined, "16.4%");
const cardsFirstRow: Card[] = [card1, card2, card3];
const cardsSecondRow: Card[] = [card4, card5, card6];

export const ALL_CARD_ROWS: Record<number, Card[]> = {
  [0]: cardsFirstRow,
  [1]: cardsSecondRow
}
// -- 

// EXPERIENCE CARDS
export const EYE_BROWN_HEADER_CARDS_TWO = "Want in? Here’s how:";
export const TITLE_CARDS_EXP = "Follow these steps ";
export const SUB_TITLE_CARDS_EXP = "to become a Dynatrace Pro";
const cardExp1: Card = new Card("", "", cardImage, <div><span style={{color: "#007bff"}}><b>1.</b></span> Complete your Associate Certification, and progress to the Professional Certification training.<br></br><br></br><br></br> 
<a  href={"https://partners.dynatrace.com/#/page/associate_bootcamp"}>{">"} Get Associate certified</a></div>);
const cardExp2: Card = new Card("", "", cardImage2, <div><span style={{color: "#007bff"}}><b>2.</b></span> Achieve your Dynatrace Professional certification, by passing your exams.<br></br><br></br><br></br><br></br>  
<a  href={"https://partners.dynatrace.com/#/page/professional_bootcamp"}>{">"} Take your professional certification</a></div>);
const cardExp3: Card = new Card("", "", cardImage3, <div><span style={{color: "#007bff"}}><b>3.</b></span> And that’s it! We'll take care of the rest! You’ll receive an invitation email and a quick form to complete for your Pro Club welcome pack.<br></br><br></br></div>);
const cardsExpFirstRow: Card[] = [cardExp1, cardExp2, cardExp3];

export const ALL_CARD_EXP_ROWS: Record<number, Card[]> = {
  [0]: cardsExpFirstRow
}

export const CARDS_FINAL_TEXT = "We'll take care of the rest! You’ll receive an invitation email and a quick form to complete for your Pro Club welcome pack.";


// SIGN UP
export const SIGN_UP_TITLE = "Go Pro with Dynatrace";
export const SIGN_UP_SUB_TITLE = "Already a member? Simply click below to gain access to your membership benefits. Ready to get started? Simply head to DTU to start your journey.";
export const BUTTON_LINK = process.env.REACT_APP_ZINFI_URL +"/concierge/ucm/#/ucm/2028/content"; // put the zinfi link when you have the link - this link is staging
export const BUTTON_NAME = "View Members Area";
// --

// FAQs
export const TITLE_ONE = "How can I become a member?";
export const TITLE_TWO = "How does a partner become a member?";
export const TITLE_THREE = "What happens if a partner doesn’t pass the Professional exam, or the certification expires?";
export const TITLE_FOUR = "How long is the certification valid for?";
export const TITLE_FIVE = "Are there any Dynatrace representatives in Pro Club?";
export const TITLE_SIX = "What are the partner benefits of Pro Club?";

export const SUB_TITLE_ONE = "Pro Club is open to all Dynatrace partners who achieve their Dynatrace Professional certification (or above).";
export const SUB_TITLE_TWO = "Once a partner receives their Professional certification, they will soon receive their ‘official’ invitation via email and can redeem their welcome pack.";
export const SUB_TITLE_THREE = "Members must maintain their certification. If a certification expires, the partner has 3 months in which to re-certify. If a partner chooses not to re-certify or doesn’t pass their exams within the timeframe, their membership expires.";
export const SUB_TITLE_FOUR = "The Professional certification is valid for 2 years.";
export const SUB_TITLE_FIVE = <div>Oh yes! We have an ambassadorial team for each Geo, who will head up the Club and will be involved throughout the journey.<br></br>
  ·&nbsp;&nbsp; GLOBAL: Alasdair Patton, Ahmed El-Jafoufi 
  <br></br> 
  ·&nbsp;&nbsp; APAC: Jason Nai, Ashok Swaminathan​ 
  <br></br> 
  ·&nbsp;&nbsp; EMEA: Rodrigo Pascoal, Steve Weinert​ 
  <br></br> 
  ·&nbsp;&nbsp; LATAM: Nestor Zapata, Ricardo Rea​ 
  <br></br> 
  ·&nbsp;&nbsp; NORAM: Russel Wilkinson, Jai Ramaswamy</div>;
export const SUB_TITLE_SIX = <div>
  <div className="ml-2">
      ·&nbsp;&nbsp; Personal recognition of achievement and validation of skills
      <br></br>
      ·&nbsp;&nbsp; Career development - stand out from your peers and position yourself as a Dynatrace champion within your organization
      <br></br>
      ·&nbsp;&nbsp; Early access to product news, features and tools
      <br></br>
      ·&nbsp;&nbsp; Special gifts, including celebratory welcome pack
      <br></br>
      ·&nbsp;&nbsp; ​Exclusive access to the Dynatrace Pro Club Ambassador Team
      <br></br>
      ·&nbsp;&nbsp; Personal invitations to attend elite Pro Club Meet up events and network with the Dynatrace Executive Team
      <br></br>
      ·&nbsp;&nbsp; Opportunity to contribute and participate in Dynatrace technical advocacy
      <br></br>
      ·&nbsp;&nbsp; ​Promotion of achievement and accreditation via the Dynatrace marketing and PR machine
  </div>
</div>;


